import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../../theme/theme";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import { emailRegex, phoneNo } from "../../Regex";
import CustomAlertLabel from "../CustomAlertLabel/CustomAlertLabel";
import {
  resetUserAccountDetails,
  setUserAccountDetails,
} from "../../redux/actions";
import Tooltip from "../Base/Tooltip";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Auth } from "aws-amplify";
import { SET_LOADING } from "../../redux/action-types";
import AccDetailsBackdrop from "../AccDetailsBackdrop";

const ModalBody = styled.div`
  height: 90%;
  width: 80%;
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .modalHeader {
    display: flex;
    justify-content: space-around;
  }

  .cross {
    height: 35px;
    width: 35px;
    & button {
      background-color: inherit;
      border: none;
      font-weight: 700;
      font-size: 32px;
      color: ${theme.colors.primaryStrong2X};
      width: 30px;

      @media (max-width: 650px) {
        right: -5px;
        top: 0px;
      }
    }
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 650px) {
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

    & button {
      font-weight: 700;
      font-size: 18px;
      padding: 10px 20px;
      color: #fff;
      background-color: ${theme.colors.primaryStrong2X};
      border-radius: 5px;
      border: none;
      cursor: pointer;
      @media (max-width: 650px) {
        font-size: 15px;
      }
    }
  }

  @media (max-width: 650px) {
    max-width: 80%;
    padding: 1.5em;

    .headerMessage {
      font-size: 20px;
    }
  }

  .subHeaderMessage {
    margin-top: 20px;
    font-weight: 700;
    font-size: 17px;
    color: ${theme.colors.primaryStrong2X};
  }

  @media (max-width: 650px) {
    .subHeaderMessage {
      font-size: 17px;
    }
  }
  .questionBox {
    margin-top: 20px;
  }
  .questionText {
    margin-top: 16px;
    font-weight: 400;
  }
  .checkBox {
    margin-right: 10px;
    cursor: pointer;
  }
  .body {
    margin-top: 30px;
  }
  .button {
    width: 100%;
    color: white;
    font-size: 15px;
    font-weight: 700;
    padding: 15px 0px;
    border: none;
    background: #6ac7dd;
    border-radius: 4px;
    cursor: pointer;
  }

  & h2 {
    margin: 0;
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};

    @media (max-width: 650px) {
      font-size: 20px;
    }
  }

  .inputBoxSection {
    margin-top: 5%;
  }

  .disclaimer {
    width: 100%;
    text-align: right;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const AccountDetailsModal = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userAccountDetails, loginSuccessResponse } = useSelector(
    (state) => state.user
  );
  const [firstName, setFirstName] = useState(userAccountDetails?.firstName);
  const [lastName, setLastName] = useState(userAccountDetails?.lastName);
  const [nickName, setNickName] = useState(userAccountDetails?.nickName);
  const [secondEmail, setSecondEmail] = useState(
    userAccountDetails?.secondEmail
  );
  const [phone, setPhone] = useState(userAccountDetails?.phone);
  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "firstName") {
      setFirstName(value);
    } else if (textBoxName === "lastName") {
      setLastName(value);
    } else if (textBoxName === "nickName") {
      setNickName(value);
    } else if (textBoxName === "phoneNo") {
      setPhone(value);
    } else if (textBoxName === "secondEmail") {
      setSecondEmail(value);
    }
  };
  const handleCustomTextBoxKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmitButtonClick();
    }
  };

  const handleSubmitButtonClick = async () => {
    if (firstName && lastName && phone && secondEmail) {
      var payload = {
        firstName: firstName,
        lastName: lastName,
        nickname: nickName || "",
        phone: phone,
        secondEmail: secondEmail,
      };
      dispatch({ type: SET_LOADING, payload: true });
      setCustomAlertMessage("");
      dispatch(resetUserAccountDetails());
      dispatch(setUserAccountDetails(payload));
      props.onClose(false);
      await Auth.forgetDevice();
      await Auth.updateUserAttributes(loginSuccessResponse, {
        phone_number: `+1${phone}`,
      });
    } else {
      let errorCount =
        Number(!secondEmail) +
        Number(!firstName) +
        Number(!lastName) +
        Number(!phone);
      setCustomAlertMessage(
        `${!secondEmail ? "Recovery email, " : ""}${
          !firstName ? "First name, " : ""
        }${!lastName ? "Last name, " : ""}${!phone ? "Mobile Phone, " : ""}${
          errorCount > 1 ? "are" : "is a "
        } mandatory field${errorCount > 1 ? "s" : ""}`.replace(
          ",",
          `${errorCount == 1 ? " " : ","}`
        )
      );
    }
  };
  const [isRepeteadMail, setIsRepeteadMail] = useState(false);
  return (
    <>
      <AccDetailsBackdrop>
        <ModalBody>
          <div className="modalHeader">
            <div className="headerMessage">
              <h2> Account Details</h2>
              <button onClick={() => history.push("/document")}>
                View Documents
              </button>
            </div>
            <div className="cross">
              <button
                onClick={() => {
                  props.onClose(false);
                }}
                style={{
                  float: "right",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                X
              </button>
            </div>
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="Recovery Email"
              errorMessage={
                isRepeteadMail
                  ? "Cannot be the same email you signed up with"
                  : "Enter a valid email"
              }
              name="secondEmail"
              regexCode={emailRegex}
              onBlur={handleCustomTextBoxOnBlur}
              onKeyPress={handleCustomTextBoxKeyPress}
              setIsRepeteadMail={setIsRepeteadMail}
              isRepeteadMail={isRepeteadMail}
              value={userAccountDetails?.secondEmail || ""}
            />
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="First Name"
              errorMessage="Not a valid name"
              name="firstName"
              value={userAccountDetails?.firstName || ""}
              onBlur={handleCustomTextBoxOnBlur}
              onKeyPress={handleCustomTextBoxKeyPress}
            />
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="Last Name"
              errorMessage="Not a valid name"
              value={userAccountDetails?.lastName || ""}
              name="lastName"
              onBlur={handleCustomTextBoxOnBlur}
              onKeyPress={handleCustomTextBoxKeyPress}
            />
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="What your friends call you"
              errorMessage="Not a valid name"
              name="nickName"
              value={userAccountDetails?.nickname || ""}
              onBlur={handleCustomTextBoxOnBlur}
              onKeyPress={handleCustomTextBoxKeyPress}
            />
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="Mobile Phone"
              errorMessage="Phone number should be 10 digits"
              name="phoneNo"
              value={userAccountDetails?.phone || ""}
              regexCode={phoneNo}
              onBlur={handleCustomTextBoxOnBlur}
              onKeyPress={handleCustomTextBoxKeyPress}
            />
          </div>
          <div className="disclaimer">
            Phone disclaimer
            <Tooltip
              className={`${window.screen.width > 480 ? "right" : "left"}`}
              text="You are consenting to be contacted at this phone number for account verification and marketing purposes from Tactive. Wireless and text message fees from your carrier may apply. Your phone number will only be used consistent with our Privacy Policy."
            />
          </div>
          <div className="questionBox">
            <CustomAlertLabel message={customAlertMessage} />
            <button className="button" onClick={handleSubmitButtonClick}>
              Save
            </button>
          </div>
        </ModalBody>
      </AccDetailsBackdrop>
    </>
  );
};
export default AccountDetailsModal;
